import { logD, logE } from "@blacknut/logging/dist";
import { LOGGING_TAG } from "../logging";

export const requestFullscreen = (document: Document) => {
  const requestFullscreen = document.documentElement.requestFullscreen;
  if (!requestFullscreen) {
    if ((document.documentElement as any).webkitRequestFullscreen) {
      logD(LOGGING_TAG, "Requesting fullscreen using legacy apis");
      //Returns a Promise: false
      //options.navigationUI parameter: false
      (document.documentElement as any).webkitRequestFullscreen({
        navigationUI: "hide",
      });
      return Promise.resolve();
    } else {
      logE(LOGGING_TAG, "No fullscreen API");
      return Promise.reject("No fullscreen API");
    }
  }
  logD(LOGGING_TAG, "Requesting fullscreen using newer apis");
  return document.documentElement.requestFullscreen({ navigationUI: "hide" });
};
